<script lang="ts" module>
  import { generateId, reactiveContext } from "#lib/internal/helpers"
  import type { VariantProps } from "class-variance-authority"

  const key = "dialogKey"

  type CVA = VariantProps<typeof contentVariants>

  type DialogRootContext = {
    open: boolean
    variant: CVA["variant"]
    spacing: CVA["spacing"]
    triggeredId: string | null
    overlay: boolean
    titleId: string
    descriptionId: string
    contentId: string
  }

  const { getContext, setContext } = reactiveContext<DialogRootContext>(
    {
      open: false,
      variant: null,
      triggeredId: null,
      spacing: "legacy",
      overlay: true,
      titleId: generateId(),
      descriptionId: generateId(),
      contentId: generateId(),
    },
    key
  )

  export const getDialogRootContext = getContext

  export type DialogRootProps = {
    open?: boolean
    overlay?: boolean
    variant?: CVA["variant"]
    spacing?: CVA["spacing"]
    children?: Snippet
  }
</script>

<script lang="ts">
  import type { Snippet } from "svelte"
  import type { contentVariants } from "."

  type Props = {
    open?: boolean
    overlay?: boolean
    variant?: CVA["variant"]
    spacing?: CVA["spacing"]
    children?: Snippet
  }

  let {
    open = $bindable(false),
    overlay = $bindable(true),
    variant = "modal",
    spacing = "legacy",
    children,
  }: Props = $props()

  const rootCtx = setContext({
    open: (v) => {
      if (v !== open) open = v
    },
    overlay: (v) => {
      if (v !== overlay) overlay = v
    },
  })

  $effect(() => {
    rootCtx.update((v) => ({ ...v, variant, open, spacing, overlay }))
  })
</script>

{@render children?.()}
